import React from "react";
import indexStyles from "./index.module.scss";
import Layout from "../components/layout";
import SEO from "../components/seo";
import jake from "../images/jake.jpg";
import paige from "../images/paige.jpg";
import applePodcast from "../images/podcastListen.svg";
import {graphql, useStaticQuery} from 'gatsby';
import {Link} from 'gatsby';

const IndexPage = () => {
  const data = useStaticQuery(graphql`
  query{
    site{
      siteMetadata{
        description
      }
    }
    allContentfulPodcast(limit: 2, sort: {fields: episode, order: DESC}){
      edges{
        node{
          title
          description
          slug
          id
          episode
          country
          bookCover{
            resize(width:100, height:120){
              src
            }
          }
        }
      }
    } 
  }
  `);

  return (
  <Layout>
    <SEO title="Home" />


    <section className={indexStyles.section}>
      <h1> About </h1>
      <p className={indexStyles.slogan}>{data.site.siteMetadata.description}</p>
      <p className={indexStyles.para}> Backpacking the world through books! <br/><br/>
       We read a book from different countries with the locals who can extend our
       understanding beyond the pages. </p>
    </section>
    
    <section className={indexStyles.section}>
      <h1>Episodes</h1>
      <div className={indexStyles.socialBtns}>
        <a href="https://podcasts.apple.com/us/podcast/paperbacker-podcast/id1525049343" target="_blank" rel="noopener noreferrer"><img src={applePodcast} alt="apple podcast" /></a>
      </div>
      <h2> Choose one:</h2>
        <ul className={indexStyles.indxPodLst}>
            {data.allContentfulPodcast.edges.map((edge) => {
              return(
                <Link key={edge.node.id} to={`/podcast/${edge.node.slug}`}>
                  <li className={indexStyles.list} key={edge.node.id}>
                  <img 
                      src={edge.node.bookCover.resize.src}
                      alt={edge.node.title} />
                    <p>{edge.node.title}</p>
                    <p>{edge.node.country}</p>
                  </li>
                </Link> 
            )})}
        </ul>
    </section>
    <section className={indexStyles.section}>
      <h1> Recommendation: </h1>
      <form className={indexStyles.contactForm} name="recommendations" action="/thanks" method="POST" data-netlify="true">
        <input type="hidden" name="form-name" value="recommendations" />
        <p>
          <label>Your Name: <input type="text" name="name" required /></label>   
        </p>
        <p>
          <label>Your Email: <input type="email" name="email" required /></label>
        </p>
        <p>
          <label>Type: <select style={{overflow: "hidden", width: "60px", padding: "5px"}} name="type[]" multiple required>
              <option value="book">Book</option>
              <option value="guest">Guest</option>
            </select>
          </label>
        </p>
        <p>
          <label>Tell us about your recommendation:<br />
          <textarea 
                name="message"
                maxLength="400" 
                cols="30"
                rows="15"
                autoComplete="off" 
                required>
          </textarea>
          </label>
        </p>
        <p>
          <button type="submit">Send</button>
        </p>
      </form>
      </section>

    <section className={indexStyles.section}>
      <div className={indexStyles.team}>
      <h1> Meet the Team </h1>
          <div className={indexStyles.hostImg}>
            <h2> Jake </h2>
            <img src={jake} alt="Jake" />
          </div>      
          <div className={indexStyles.hostImg}>
            <h2> Paige </h2>
            <img src={paige} alt="Page" ></img>
          </div>
      </div>
    </section>

  </Layout>
    
  )
}

export default IndexPage
